require('./fiscalInformationLinks.scss');
//@vendor
const React = require('react');
//@utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
//@commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
//@const
const TRANSLATION_KEY = 'fiscalInformationLinks';

const FiscalInformationLinks = () => {
    const title = formatText(`${TRANSLATION_KEY}-title`);
    const taxAgencyLink = formatText(`${TRANSLATION_KEY}-taxAgencyLink`);
    const taxPayerCalendarLink = formatText(`${TRANSLATION_KEY}-taxPayerCalendarLink`);

    return (
        <div className="fiscal-information-links">
            <OKSectionBox title={title}>
                <div className="fiscal-information-links__item">
                    <OKLink
                        modifier="complementary"
                        to={taxAgencyLink}
                        target="_blank"
                    >
                        <FormattedText value={`${TRANSLATION_KEY}-${TRANSLATION_KEY}_taxAgencyText`} />
                    </OKLink>
                </div>
                <div className="fiscal-information-links__item">
                    <OKLink
                        modifier="complementary"
                        to={taxPayerCalendarLink}
                        target="_blank"
                    >
                        <FormattedText value={`${TRANSLATION_KEY}-${TRANSLATION_KEY}_taxPayerCalendarText`} />
                    </OKLink>
                </div>
            </OKSectionBox>
        </div>
    );
};

module.exports = FiscalInformationLinks;
